export const DIAS_EXPIRACAO = {
  WARN: 2,
  SUCESS: 4
}

export const getExpiracaoTextColorClass = (dias) => {
  if (dias >= DIAS_EXPIRACAO.SUCESS) return 'darkwhite--text'
  if (dias >= DIAS_EXPIRACAO.WARN) return 'advice_friendly_text--text'
  return 'darkwhite--text'
}

export const getBackgroundColor = (dias) => {
  if (dias >= DIAS_EXPIRACAO.SUCESS) return 'success'
  if (dias >= DIAS_EXPIRACAO.WARN) return 'warning'
  return 'error'
}

export const getIcon = (dias) => {
  if (dias >= DIAS_EXPIRACAO.SUCESS) return 'mdi-check-circle-outline'
  if (dias >= DIAS_EXPIRACAO.WARN) return 'mdi-alert-octagon-outline'
  return 'mdi-alarm-light-outline'
}
